import React, { useState } from 'react';
import Styles from '../styles/components/NewServiceForm.module.css';

const NewServiceForm = ({ onSubmit }) => {
    const [formMessage, setFormMessage] = useState(null);
    const [formData, setFormData] = useState({
        service_date: '',
        notes: '',
        communion: false,
        hymn_leader: '',
    });

    // Ajax Functions



    // Handle any change to the form data and update the state of formData
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    // Event Handlers
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <form className={Styles.formContainer} onSubmit={handleSubmit}>
            <div className={Styles.formGroup}>
                <label htmlFor="service_date">Service Date:</label>
                <input type="date" id="service_date" name="service_date" required value={formData.service_date} onChange={handleChange} />
            </div>

            <div className={Styles.formGroup}>
                <label htmlFor="hymn_leader">Hymn Leader:</label>
                <input type="text" id="hymn_leader" name="hymn_leader" value={formData.hymn_leader} onChange={handleChange} />
            </div>

            <div className={Styles.formGroup}>
                <label htmlFor="communion">Communion:</label>
                <input type="checkbox" id="communion" name="communion" checked={formData.communion} onChange={handleChange} />
            </div>

            <div className={Styles.formGroup}>
                <label htmlFor="notes">Notes:</label>
                <textarea id="notes" name="notes" rows="3" value={formData.notes} onChange={handleChange} />
            </div>

            <button type="submit" className={Styles.submitButton}>Create Service</button>
        </form>
    );
};

export default NewServiceForm;
